import {
  UserServiceClient
} from "@/proto/user_grpc_web_pb";
import { 
  User, 
  ListUserRequest,
  ItemUserRequest,
  UserFilter,
  UserSort,
  UserPagination,
  CreateUserRequest,  
  UpdateUserRequest, 
  DeleteUserRequest
} from "@/proto/user_pb";
import {handleRefreshToken} from '@/main'

// Количество на странице по-умолчанию
const defaultLimit:number = 100;

export class UserApi {
  items: Array<User> = [];
  client: UserServiceClient;

  constructor() {
    const host:string = (window as any).VUE_APP_API_URL ?? '';
    this.client = new UserServiceClient(host, null, null);
  }

  getAuth(){
    const metadata: any = {
      Authorization: localStorage.getItem('accessToken')
    }
    return metadata
  }

  // Установка и получение фильтров
  createFilter(data: any){

    const filter = new UserFilter();
    const userId:number = data.userId !== undefined ? parseInt(data.userId) : 0;
    const email:string = data.email !== undefined ? data.email.toString() : "";
    const lastName:string = data.lastName !== undefined ? data.lastName.toString() : "";
    const firstName:string = data.firstName !== undefined ? data.firstName.toString() : "";
    const middleName:string = data.middleName !== undefined ? data.middleName.toString() : "";

    // Устанавливаем фильтры
    filter.setUserId(userId);
    filter.setEmail(email);
    filter.setLastName(lastName);
    filter.setFirstName(firstName);
    filter.setMiddleName(middleName);

    return filter;
  }

  // Установка и получение сортировки
  createSort(data: any){

    const sort = new UserSort();
    const name:string = data.name !== undefined ? data.name.toString() : "email";
    const exp:string = data.exp !== undefined ? data.exp.toString() : "asc";

    // Устанавливаем параметры сортировки
    sort.setName(name);
    sort.setExp(exp);

    return sort;
  }

  // Установка и получение пагинации
  createPagination(data: any){

    const pagination = new UserPagination();
    const page:number = data.page !== undefined ? Number(data.page) : 1;
    const limit:number = data.limit !== undefined ? Number(data.limit) : defaultLimit;

    // Устанавливаем пагинацию
    pagination.setPage(page);
    pagination.setLimit(limit);
    pagination.setPages(0);

    return pagination;
  }

  // Список элементов
  getUserItems(filter: any, sort: any, pagination: any){

    const request = new ListUserRequest();

    // Устанавливаем параметры запроса
    request.setFilter(this.createFilter(filter));
    request.setSort(this.createSort(sort));
    request.setPagination(this.createPagination(pagination));

    return new Promise((resolve, reject) => {
      this.client.listUser(request, this.getAuth(), (err, message) => {
        if (err) {
          handleRefreshToken()
          reject(err)
        } else {
          resolve(message.getItemsList());
        }
      });
    });
  }

  // Получение элемента
  getUserItem(filter: any){

    const request = new ItemUserRequest();

    // Устанавливаем параметры запроса
    request.setFilter(this.createFilter(filter));

    return new Promise((resolve, reject) => {
      this.client.itemUser(request, this.getAuth(), (err, message) => {
        if (err) {
          handleRefreshToken()
          reject(err)
        } else {
          resolve(message.getItem());
        }
      });
    });
  }

  // Создание элемента
  createUserItem(data: any){

    const request = new CreateUserRequest();
    request.setPortalCode(data.portalCode);
    request.setEmail(data.email);
    request.setLastName(data.lastName);
    request.setFirstName(data.firstName);
    request.setMiddleName(data.middleName);

    return new Promise((resolve, reject) => {
      this.client.createUser(request, this.getAuth(), (err, message) => {
        if (err) {
          handleRefreshToken()
          reject(err)
        } else {
          resolve(message);
        }
      });
    });
  }

  // Редактирование элемента
  updateUserItem(data: any){

    const request = new UpdateUserRequest();
    request.setUserId(data.userId);
    request.setPortalCode(data.portalCode);
    request.setEmail(data.email);
    request.setLastName(data.lastName);
    request.setFirstName(data.firstName);
    request.setMiddleName(data.middleName);

    return new Promise((resolve, reject) => {
      this.client.updateUser(request, this.getAuth(), (err, message) => {
        if (err) {
          handleRefreshToken()
          reject(err);
        } else {
          resolve(message);
        }
      });
    });
  }

  // Удаление элемента
  deleteUserItem(data: any){

    const request = new DeleteUserRequest();
    request.setUserId(data.userId);

    return new Promise((resolve, reject) => {
      this.client.deleteUser(request, this.getAuth(), (err, message) => {
        if (err) {
          handleRefreshToken()
          reject(err);
        } else {
          resolve(message);
        }
      });
    });
  }
}